module.exports = __webpack_public_path__ + "img/fc.5d069472.jpeg";